<template>
  <div class="col-20 text-center">
    <div
      v-if="wait"
      class="mb-2"
    >
      {{ isAdvertiser ? $t('view-CampaignsFiles.status-info.advertiser.wait') : $t('view-CampaignsFiles.status-info.influencer.wait') }}
    </div>
    <div
      v-if="end"
      class="mb-2"
    >
      {{ isAdvertiser ? $t('view-CampaignsFiles.status-info.advertiser.end') : $t('view-CampaignsFiles.status-info.influencer.end') }}
    </div>
    <div
      v-if="skip"
      class="mb-2"
    >
      {{ isAdvertiser ? $t('view-CampaignsFiles.status-info.advertiser.skip') : $t('view-CampaignsFiles.status-info.influencer.skip') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      default: () => { return {} }
    },
    isAdvertiser: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    skip () {
      const correctStatuses = ['invite_rejected']
      return correctStatuses.includes(this.member.status)
    },
    wait () {
      const correctStatuses = ['invite_accepted', 'invited']
      return correctStatuses.includes(this.member.status)
    },
    end () {
      const correctStatuses = ['completed', 'expired', 'canceled']
      return correctStatuses.includes(this.member.status)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
